export { default as ParcelTrackingPickupViewPage } from './pickup-view';